import UIErrorMessage from '$shared/constants/UIErrorMessage';
import dayjs from 'dayjs';

export class DOBValidator {
  static validate(value: string): void {
    if (!value) return;
    const enteredValue = dayjs(new Date(value));
    if (enteredValue.isBefore('1900', 'year'))
      throw new Error(UIErrorMessage.UnsupportedDateOfBirth);

    const minDate = dayjs().subtract(15, 'years');

    if (enteredValue.isBefore(minDate.year().toString(), 'year')) return;

    throw new Error(UIErrorMessage.DOBYoungerThanSupported);
  }
}
